module.exports = __webpack_public_path__ + "img/3.cd4517bb.png";